import React from 'react'
import {Row, Col} from 'antd'
import {Helmet} from "react-helmet";
import './SuccessInfoCollection.css'
import group from './group.JPG'

export default function SuccessInfoCollection(props){
	return(
		<Row justify="center">
            <Helmet>
                <title>Thank You | Jack Yan for Mayor of Toronto: Official Campaign Website</title>
            </Helmet>   		
			<Row>
				<div className="thank-you-header blue-text-800" >Thank you for your support! We will be in touch. Together, we can make a difference.
				</div>
			</Row>
			<Row justify="center">
				<Col xs={23} md={18} lg={12}>
					<img style={{width:"100%", marginBottom:"3em"}}src={group}/>
				</Col>
			</Row>		
		</Row>
		)
}